<script>
import { layoutComputed } from "@/state/helpers";

import Vertical from "./vertical";
import Horizontal from "./horizontal";

/**
 * Layout principal — seleciona o sub-layout conforme o estado do Vuex.
 *
 * layoutType pode ser: 'vertical', 'semibox', 'horizontal'.
 *
 * Cada view autenticada deve importar este componente e envolver seu conteudo:
 *
 *   <Layout>
 *     <div>...conteudo da pagina...</div>
 *   </Layout>
 */
export default {
  components: { Vertical, Horizontal },
  computed: {
    ...layoutComputed,
  },
  watch: {
    layoutType: {
      immediate: true,
      handler() {
        this.aplicarAtributosLayout();
      },
    },
    sidebarSize() {
      this.aplicarAtributosLayout();
    },
    layoutWidth() {
      this.aplicarAtributosLayout();
    },
    topbar() {
      this.aplicarAtributosLayout();
    },
    position() {
      this.aplicarAtributosLayout();
    },
    sidebarColor() {
      this.aplicarAtributosLayout();
    },
    sidebarImage() {
      this.aplicarAtributosLayout();
    },
    visibility() {
      this.aplicarAtributosLayout();
    },
  },
  methods: {
    aplicarAtributosLayout() {
      const root = document.documentElement;
      const layout = this.layoutType || 'vertical';
      const sidebarSize = this.sidebarSize || 'sm-hover';
      const layoutWidth = this.layoutWidth || 'fixed';
      const topbar = this.topbar || 'dark';
      const position = this.position || 'scrollable';
      const sidebar = this.sidebarColor || 'dark';
      const sidebarImage = this.sidebarImage || 'none';
      const visibility = this.visibility || 'show';

      root.setAttribute('data-layout', layout);
      root.setAttribute('data-sidebar-size', sidebarSize);
      root.setAttribute('data-layout-width', layoutWidth);
      root.setAttribute('data-topbar', topbar);
      root.setAttribute('data-layout-position', position);
      root.setAttribute('data-sidebar', sidebar);
      root.setAttribute('data-sidebar-image', sidebarImage);
      root.setAttribute('data-sidebar-visibility', visibility);
    },
  },
};
</script>

<template>
  <div>
    <Vertical v-if="layoutType === 'vertical' || layoutType === 'semibox'" :layout="layoutType">
      <slot />
    </Vertical>

    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
      <slot />
    </Horizontal>
  </div>
</template>
